export default "__VITE_ASSET__DxH0SJB2__"